const mediaItems = [
  { title: '独家实拍：某顶流深夜密会神秘女子全过程', views: '1280万', duration: '03:25', img: 'https://readdy.ai/api/search-image?query=Cinematic%20night%20scene%20abstract%20composition%20with%20warm%20streetlight%20glow%20on%20dark%20background%2C%20mysterious%20atmosphere%2C%20deep%20crimson%20and%20amber%20tones%2C%20paparazzi%20style%20aesthetic%2C%20no%20text%20no%20faces&width=800&height=450&seq=media-card-01&orientation=landscape' },
  { title: '圈内人士实名曝光选秀节目票数造假', views: '965万', duration: '08:12', img: 'https://readdy.ai/api/search-image?query=Abstract%20stage%20performance%20composition%20with%20dramatic%20spotlight%20and%20deep%20shadows%2C%20dark%20red%20and%20black%20tones%2C%20mysterious%20theatrical%20mood%2C%20editorial%20style%2C%20no%20text%20no%20faces&width=800&height=450&seq=media-card-02&orientation=landscape' },
  { title: '经纪公司紧急声明：艺人合约纠纷全面解读', views: '832万', duration: '12:08', img: 'https://readdy.ai/api/search-image?query=Abstract%20press%20conference%20composition%20with%20microphone%20silhouettes%20and%20dramatic%20lighting%2C%20dark%20burgundy%20background%2C%20serious%20editorial%20mood%2C%20no%20text%20no%20faces&width=800&height=450&seq=media-card-03&orientation=landscape' },
  { title: '知名编剧实名举报平台拖欠千万稿酬', views: '756万', duration: '05:40', img: 'https://readdy.ai/api/search-image?query=Abstract%20legal%20document%20and%20gavel%20concept%20on%20dark%20background%2C%20warm%20amber%20and%20gold%20accents%2C%20serious%20investigative%20mood%2C%20cinematic%20editorial%20style%2C%20no%20text%20no%20faces&width=800&height=450&seq=media-card-04&orientation=landscape' },
  { title: '综艺录制现场冲突画面流出，多方回应', views: '689万', duration: '02:58', img: 'https://readdy.ai/api/search-image?query=Abstract%20dramatic%20confrontation%20visual%20with%20clashing%20warm%20and%20cool%20tones%2C%20dark%20crimson%20and%20gold%20lighting%2C%20tense%20cinematic%20atmosphere%2C%20editorial%20composition%2C%20no%20text%20no%20faces&width=800&height=450&seq=media-card-05&orientation=landscape' },
];

export default function MediaSection() {
  return (
    <section id="media" className="py-14 md:py-20 px-4 md:px-6 bg-background-100">
      <div className="max-w-7xl mx-auto">
        <div className="mb-10">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-2">
            热门视频
          </h2>
          <p className="text-sm text-foreground-500">吃瓜爆料视频专区，实拍爆料一网打尽</p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
          {mediaItems.slice(0, 3).map((item, i) => (
            <a key={i} href="#media" className="group cursor-pointer">
              <div className="relative overflow-hidden rounded-xl bg-background-50 border border-background-200 hover:border-primary-200 transition-all">
                <div className="relative aspect-video overflow-hidden">
                  <img
                    src={item.img}
                    alt={`吃瓜爆料视频 - ${item.title}`}
                    className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                    loading={i >= 1 ? 'lazy' : undefined}
                  />
                  <div className="absolute inset-0 bg-black/20 group-hover:bg-black/30 transition-colors flex items-center justify-center">
                    <div className="w-14 h-14 rounded-full bg-primary-500/90 flex items-center justify-center group-hover:bg-primary-500 transition-colors">
                      <i className="ri-play-fill text-background-50 text-2xl ml-0.5"></i>
                    </div>
                  </div>
                  <div className="absolute bottom-2 right-2 px-2 py-0.5 rounded bg-black/70 text-background-50 text-xs font-medium">
                    {item.duration}
                  </div>
                </div>
                <div className="p-4">
                  <h3 className="text-sm font-semibold text-foreground-800 group-hover:text-primary-600 transition-colors line-clamp-2 leading-snug">
                    {item.title}
                  </h3>
                  <p className="text-xs text-foreground-500 mt-2">
                    <i className="ri-eye-line mr-1"></i>{item.views} 次观看
                  </p>
                </div>
              </div>
            </a>
          ))}
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 md:gap-5 mt-4 md:mt-5">
          {mediaItems.slice(3, 5).map((item, i) => (
            <a key={i + 3} href="#media" className="group cursor-pointer">
              <div className="relative overflow-hidden rounded-xl bg-background-50 border border-background-200 hover:border-primary-200 transition-all">
                <div className="relative aspect-video overflow-hidden">
                  <img
                    src={item.img}
                    alt={`吃瓜爆料视频 - ${item.title}`}
                    className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                    loading="lazy"
                  />
                  <div className="absolute inset-0 bg-black/20 group-hover:bg-black/30 transition-colors flex items-center justify-center">
                    <div className="w-14 h-14 rounded-full bg-primary-500/90 flex items-center justify-center group-hover:bg-primary-500 transition-colors">
                      <i className="ri-play-fill text-background-50 text-2xl ml-0.5"></i>
                    </div>
                  </div>
                  <div className="absolute bottom-2 right-2 px-2 py-0.5 rounded bg-black/70 text-background-50 text-xs font-medium">
                    {item.duration}
                  </div>
                </div>
                <div className="p-4">
                  <h3 className="text-sm font-semibold text-foreground-800 group-hover:text-primary-600 transition-colors line-clamp-2 leading-snug">
                    {item.title}
                  </h3>
                  <p className="text-xs text-foreground-500 mt-2">
                    <i className="ri-eye-line mr-1"></i>{item.views} 次观看
                  </p>
                </div>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}